import { render, staticRenderFns } from "./Toolbar.vue?vue&type=template&id=9334526a&"
import script from "./Toolbar.vue?vue&type=script&lang=js&"
export * from "./Toolbar.vue?vue&type=script&lang=js&"
import style0 from "./Toolbar.vue?vue&type=style&index=0&id=9334526a&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/zhishengluo/opp-scratch/scratch/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9334526a')) {
      api.createRecord('9334526a', component.options)
    } else {
      api.reload('9334526a', component.options)
    }
    module.hot.accept("./Toolbar.vue?vue&type=template&id=9334526a&", function () {
      api.rerender('9334526a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/classroom1/components/whiteboard/Toolbar.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/classroom1/components/whiteboard/Toolbar.vue
// module id = oJ/g
// module chunks = 0